import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  getBlogById,
  updateBlog,
} from "../../../../services/operations/blogApi";
import BlogEditorForm from "./BlogEditorForm";

const EditBlog = () => {
  const { blogId } = useParams();
  const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    getBlogById(blogId).then(setBlog);
  }, [blogId]);

  const saveBlog = async (payload) => {
    const updatedBlog = await updateBlog(payload, blogId, token);
    if (updatedBlog) navigate("/dashboard/blogs");
    return updatedBlog;
  };

  if (!blog) {
    return <div className="p-10 text-richblack-5">Loading blog...</div>;
  }

  return (
    <div className="p-6 text-richblack-5 sm:p-10">
      <h1 className="mb-2 text-3xl font-bold">Edit Blog</h1>
      <p className="mb-8 text-richblack-300">
        Update the article text, cover, and supporting images.
      </p>
      <BlogEditorForm
        key={blog._id}
        initialValue={blog}
        token={token}
        submitLabel="Update Blog"
        onSubmit={saveBlog}
      />
    </div>
  );
};

export default EditBlog;
